import { createI18n } from 'vue-i18n'

const fileNameToLocaleModuleDict = import.meta.glob<{ default: Record<string, any> }>(
  './locales/**/*.json',
  {
    eager: true,
  }
)

const messages: { [locale: string]: Record<string, any> } = {}

Object.entries(fileNameToLocaleModuleDict).forEach(([fileName, localeModule]) => {
  const pathParts = fileName.split('/')
  const localeName = pathParts[pathParts.length - 2]

  if (!messages[localeName]) {
    messages[localeName] = {}
  }

  messages[localeName] = { ...messages[localeName], ...localeModule.default }
})

const language = location.pathname.startsWith('/calculator')
  ? localStorage.getItem('cooler_language')
  : 'zh-CN'

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: language || 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages,
})
